import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default  new Vuex.Store({
    state:{      
      idEmpresa:null,
      idCliente:null,
      razaoSocial:'',
      tipoNota:'NFe',
      chave:'',
      opNota:'',
    }   ,
         
  })